<template>
  <div>
    <el-card class="box-card"
      v-for="(remark, idx) in remarksValue"
      :key="remark.id">
      <text-field
          v-model="remark.title"
          :base="base"
          :disabled="true"
          name="remark_title">
      </text-field>
      <text-field
          v-model="remark.content"
          :base="base"
          :disabled="checkDisabledRemarkType(remark.remark_type)"
          @input="val => changeRemarkValue(idx, val)"
          name="remark_content"
          type="textarea">
      </text-field>
    </el-card>
    <text-field
      v-model="memberNote"
      :base="base"
      name="member_note"
      type="textarea">
    </text-field>
    <text-field
      v-model="cancelReason"
      :base="base"
      name="cancel_reason"
      type="textarea">
    </text-field>
    <text-field
      v-model="noteValue"
      :base="base"
      name="note"
      type="textarea">
    </text-field>
    <text-field
      v-model="managerMessageValue"
      disabled
      :base="base"
      name="manager_message"
      type="textarea">
    </text-field>
    <text-field
      v-if="usen_seat"
      v-model="usen_seat"
      disabled
      :base="base"
      name="usen_seat"
      type="textarea">
    </text-field>
    <el-button
      class="save-btn"
      type="primary"
      :loading="isSubmitLoading"
      @click="handleSaveBtnClick"
      >
      {{ $t('api.saveBtn') }}
    </el-button>
  </div>
</template>

<script>

import { updateOrdersNotes } from '@/api/orders/orders'
import { getTransText } from '@/utils/i18n'
import { RemarkType } from '@/enums/remark'
import { getTimeText } from '@/utils/time'

const BYPASS_REMARK_TYPE = [
  RemarkType.Quantity,
  RemarkType.Checkbox,
  RemarkType.PureText,
  RemarkType.Picture
]

export default {
  name: 'orders-remark',
  props: {
    base: {
      type: String,
      default: ''
    },
    member_note: {
      type: String,
      default: ''
    },
    cancel_reason: {
      type: String,
      default: ''
    },
    note: {
      type: String,
      default: ''
    },
    remarks: {
      type: Array,
      default: () => []
    },
    manager_message: {
      type: Array,
      default: () => []
    },
    usen_seat: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isSubmitLoading: false
    }
  },
  computed: {
    ordersId () {
      return this.$route.params.id
    },
    memberNote: {
      get () {
        return this.member_note
      },
      set (value) {
        this.$emit('update:member_note', value)
      }
    },
    cancelReason: {
      get () {
        return this.cancel_reason
      },
      set (value) {
        this.$emit('update:cancel_reason', value)
      }
    },
    noteValue: {
      get () {
        return this.note
      },
      set (value) {
        this.$emit('update:note', value)
      }
    },
    remarksValue: {
      get () {
        return this.remarks
      },
      set (value) {
        this.$emit('update:remarks', value)
      }
    },
    managerMessageValue: {
      get () {
        if (!Array.isArray(this.manager_message) || !this.manager_message.length) return ''
        return this.manager_message.map(m => `${this.getTimeText(m.created_at, true)} ：${m.message}`).join('\n')
      }
    }
  },
  methods: {
    getTransText,
    getTimeText,
    async handleSaveBtnClick () {
      try {
        if (this.isSubmitLoading) return

        this.isSubmitLoading = true
        await updateOrdersNotes(this.ordersId, {
          member_note: this.member_note,
          cancel_reason: this.cancel_reason,
          note: this.note,
          remark: this.remarks
        })
        this.$message({
          message: this.$t('api.default.editSuccess', { name: this.$t('api.tabs.remark') }),
          type: 'success',
          duration: 2000
        })
      } finally {
        this.isSubmitLoading = false
      }
    },
    changeRemarkValue (idx, val) {
      this.remarksValue = this.remarksValue.map((remark, i) => i !== idx ? remark : { ...remark, content: val })
    },
    checkDisabledRemarkType (type) {
      return BYPASS_REMARK_TYPE.includes(type)
    }
  },
  mounted () {
  },
  watch: {
  }
}
</script>
